import { React, useEffect, useState } from "react";

const MInput = (props) => {
  const { onClick } = props;
  const [inputType, setInputType] = useState(props.type);

  useEffect(() => {
    setInputType("text");
  }, []);
  const handleFocus = () => {
    if (props.type === "date") {
      setInputType("date"); // Change the input type to 'date' on focus
    }
  };

  const handleBlur = (e) => {
    if (props.type === "date" && !e.target.value) {
      setInputType("text"); // Optionally revert to 'text' on blur if no date is selected
    }
  };
  const onDataClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <input
      className="form-control ps-0"
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...props}
      type={inputType}
      onClick={onDataClick}
    />
  );
};
export default MInput;
